import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const AutoInsuranceQuotesWrapper = ({
  inventoryType,
  title,
  pricingCode,
  fetchQuotesOnLoad,
  zipCode,
  disableGeolocation,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'AutoInsuranceQuotes',
        version: '1.0.0',
        props: {
          inventoryType,
          title,
          pricingCode,
          fetchQuotesOnLoad,
          zipCode,
          disableGeolocation,
        },
      }}
    </StructuredContent>
  );
};

AutoInsuranceQuotesWrapper.propTypes = {
  inventoryType: PropTypes.string,
  title: PropTypes.string,
  pricingCode: PropTypes.string,
  fetchQuotesOnLoad: PropTypes.bool,
  zipCode: PropTypes.string,
  disableGeolocation: PropTypes.bool,
};

AutoInsuranceQuotesWrapper.defaultProps = {
  title: 'Compare auto insurance',
  pricingCode: '664580',
  fetchQuotesOnLoad: true,
  zipCode: '',
  disableGeolocation: false,
};

AutoInsuranceQuotesWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('title', 'Title'),
    stringInputSpec('pricingCode', 'Pricing Code'),
    stringInputSpec('zipCode', 'Zip Code'),
    stringInputSpec('inventoryType', 'Inventory Type'),
    boolCheckboxSpec('fetchQuotesOnLoad', 'Fetch Quotes on Load'),
    boolCheckboxSpec('disableGeolocation', 'Disable Geolocation'),
  ];
};

AutoInsuranceQuotesWrapper.displayName = 'AutoInsuranceQuotesWrapper';

export default AutoInsuranceQuotesWrapper;
